<template>
  <div>
    <div class="wrapper">
      <div class="row">
        <div class="col-lg-12">
          <div id="filters">
            <div class="search col-lg-12">
              <div class="row">
                <div class="col-lg-3 col-md-3 m-t-sm">
                  <v-select
                    placeholder="Clients"
                    :options="f.clients"
                    label="name"
                    index="id"
                    multiple
                    v-model="filters['client']"
                  ></v-select>
                </div>
                <div class="col-lg-3 col-md-3 m-t-sm">
                  <v-select placeholder="Group" :options="f.groups" v-model="filters['group']" label="fullName" index="id" multiple></v-select>
                </div>
                <div class="col-lg-3 col-md-3 m-t-sm">
                  <v-select placeholder="Type" :options="['fix','content','tech']" v-model="filters['type']" multiple></v-select>
                </div>
                <div class="col-lg-3 col-md-3 m-t-sm">
                  <div class="display-flex">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 side-input-text pretty-input">Completed</div>
                    <input type="date" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" v-model="filters['dateFrom']" placeholder="From">
                    <input type="date" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" v-model="filters['dateTo']" placeholder="To">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 m-t-sm">
              <v-select
                placeholder="Orders"
                :options="orders"
                label="name"
                index="id"
                multiple
                v-model="filters['order']"
              ></v-select>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="col-lg-3 m-t-sm">
            <button class="btn btn-xs btn-primary" @click="generateReport">Generate</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>Pbn</th>
              <th>Client</th>
              <th>Content</th>
              <th>Fix</th>
              <th>Tech</th>
              <th>Blocker</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, i) in rows" :key="'results' + i">
              <td>{{ row.pbn.domain }}</td>
              <td>{{ row.pbn.client.name }}</td>
              <td>{{ row.content }}</td>
              <td>{{ row.fix }}</td>
              <td>{{ row.tech }}</td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { Query } from '../../../../mixins/helperMixin'

export default {
  data () {
    return {
      filters: {
        status: 'completed'
      },
      rows: [],
      orders: []
    }
  },
  mounted () {
    this.loadOrders()
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mixins: [Query],
  methods: {
    generateReport () {
      let query = this.buildQuery(this.filters)
      axios.get(`/maintenance/report/pbn?${query}`)
        .then(r => {
          this.rows = r.data.report
        })
    },
    loadOrders () {
      axios.get('/maintenance/orders')
        .then(r => {
          this.orders = r.data.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Reports/Maintenance.vue